import React from "react";
import { Skeleton } from "@material-ui/lab";
import { Typography } from "@material-ui/core";
import { FormattedMessage } from "react-intl";
import type { FC } from "react";

import { useSubscriptionsProviderContext } from "../../providers";
import { useStyles } from "./SubscriptionsMenu.styles";
import { SubscriptionsItemsTree } from "./SubscriptionsItemsTree";
import { messages } from "./SubscriptionsMenu.messages";

export const SubscriptionsMenu: FC = () => {
  const classes = useStyles();
  const {
    state: { isSubscriptionItemsLoading, subscriptionItems, selectedSubscriptionItemId },
    actions: { setSelectedSubscriptionItemId },
  } = useSubscriptionsProviderContext();

  if (isSubscriptionItemsLoading) {
    return <Skeleton variant="rect" width={342} height="100%" />;
  }

  return (
    <div className={classes.root}>
      {subscriptionItems.length === 0 ? (
        <Typography>
          <FormattedMessage {...messages.noSubscriptions} />
        </Typography>
      ) : (
        <SubscriptionsItemsTree value={selectedSubscriptionItemId} onChange={setSelectedSubscriptionItemId} items={subscriptionItems} />
      )}
    </div>
  );
};
